module.exports = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};




//////////////////
// WEBPACK FOOTER
// ./~/qr.js/lib/ErrorCorrectLevel.js
// module id = 610
// module chunks = 0